<template>
  <div class="dialog-scroll">
    <div class="viewable-area-style">
      <el-dialog
        class="search-popup"
        :show-close="false"
        :visible.sync="dialogVisible"
        :before-close="handleDialogClose">

        <div class="header-style">
          <div class="title-style">
            画面設定
          </div>
          <SpSmartButton class="cancel-button click-item" @click="cancel">
            キャンセル
          </SpSmartButton>
        </div>

        <el-form
          style="margin-top: 34px;"
          @submit.native.prevent
          :model="query"
          ref="selectMeetingRoomForm" >
          <el-row :gutter="16">
            <el-col class="col" style="display: flex;">
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのビル"
                  v-model="query.buildingId"
                  @change="changeBuild"
                >
                  <el-option
                    v-for="item in buildingList"
                    :key="item.buildingId"
                    :label="item.buildingName"
                    :value="item.buildingId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのフロア"
                  :disabled="query.buildingId == null || query.buildingId == ''"
                  v-model="query.floorId"
                  @change="changeFloor"
                >
                  <el-option
                    v-for="item in filterFloorList"
                    :key="item.floorId"
                    :label="item.floorName"
                    :value="item.floorId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="width: 160px !important; margin-right: 8px;">
                <el-select
                  class="el-select-size"
                  placeholder="すべてのエリア"
                  v-model="query.areaId"
                  :disabled="query.floorId == null || query.floorId == ''"
                  @change="changeArea"
                >
                  <el-option
                    v-for="item in filterAreaList"
                    :key="item.areaId"
                    :label="item.areaName"
                    :value="item.areaId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="pageName" style="width: 324px !important;">
                <el-input
                  class="input-class"
                  maxlength="50"
                  size="small"
                  placeholder="環境可視化ページ名"
                  v-model="query.pageName">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 検索結果 START -->
        <div class="search-common">
          <el-table show-header :data="filterSearchResult">
            <!--  ビル名 -->
            <el-table-column
              class-name="col-4"
              prop="buildingName"
              :label="$t('label.system.meetingRoom.search.result.buildingName')"
            />
            <!--  フロア名 -->
            <el-table-column
              class-name="col-4"
              prop="floorName"
              :label="$t('label.system.meetingRoom.search.result.floorName')"
            />
            <!--  エリア名 -->
            <el-table-column
              class-name="col-4"
              prop="areaName"
              :label="$t('label.system.meetingRoom.search.result.areaName')"
            />
            <!--  環境可視化ページ名 -->
            <el-table-column
              class-name="col-4"
              prop="pageName"
              label="環境可視化ページ名"
            />

            <el-table-column class-name="col-4">
              <div slot-scope="scope" class="detail-button with-100">
                <sp-smart-button @click="selectEnvViewPageRoom(scope.row)" class="detail-button with-100">
                  {{ $t("button.common.select") }}
                </sp-smart-button>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <!-- 検索結果 END -->

      </el-dialog>
    </div>

  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"

const EVENT_ON_SELECTED = "on-selected";

export default {
  components: {
    SpSmartButton,
  },
  props: {
    visible: Boolean,
    orgId: String,
    fromType: {
      type: String,
      default: null
    },
  },
  data: function () {
    return {
      ownerId: null,
      searchResultShowFlag: true,
      dialogVisible: this.visible,
      showSelectFloorDialog: false,
      query: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floor: null,
        areaId: null,
        areaName: null,
        pageId: null,
        pageName: null,
      },
      buildingList: [],
      floorList: [],
      areaList: [],
      searchResult: [],
      filterFloorList: [],
      filterAreaList: [],
      filterSearchResult: [],
    };
  },
  watch: {
    visible(val) {
      this.dialogVisible = val;
      if(this.orgId !== undefined && this.orgId !== null) {
        this.ownerId = this.orgId;
      }
      this.getBuildingSearch()
    },
    "query.pageName": {
      handler(newVal, oldVal) {
        this.filterSearchResult = this.searchResult
        if (!this.$IsNullOrEmpty(this.query.buildingId)) {
          this.filterSearchResult = this.filterSearchResult.filter(item => item.buildingId == this.query.buildingId)
        }

        if (!this.$IsNullOrEmpty(this.query.floorId)) {
          this.filterSearchResult = this.filterSearchResult.filter(item => item.floorId == this.query.floorId)
        }

        if (!this.$IsNullOrEmpty(this.query.areaId)) {
          this.filterSearchResult = this.filterSearchResult.filter(item => item.areaId == this.query.areaId)
        }

        if (newVal != oldVal) {
          this.filterSearchResult = this.filterSearchResult.filter(item => item.pageName.indexOf(newVal) > -1)
        }
      }
    },

  },
  methods: {
    changeBuild(val){
      this.query.buildingId = this.$IsNullOrEmpty(val) ? null : val
      this.query.floorId = null
      this.query.areaId = null
      this.query.pageName = null
      this.getFloorSearch()
      this.loadData()
    },
    changeFloor(val){
      this.query.floorId = this.$IsNullOrEmpty(val) ? null : val
      this.query.areaId = null
      this.query.pageName = null
      this.getAreaSearch()
      this.loadData()
    },
    changeArea(val){
      this.query.areaId = this.$IsNullOrEmpty(val) ? null : val
      this.query.pageName = null
      this.loadData()
    },
    selectEnvViewPageRoom(item){
      this.dialogVisible = false;
      this.$emit(EVENT_ON_SELECTED, item);
      this.$emit("update:visible", false);
    },
    getBuildingSearch(){

      let req = {
        ownerId: this.ownerId,
        pageSize: 999,
        pageNumber: 1
      }

      if (!this.$IsNullOrEmpty(this.fromType) && this.fromType == "01") {
        req = {
          ownerId: this.ownerId,
          pageSize: 999,
          pageNumber: 1,
          funcCode: "110100"
        }
      }

      SystemManageApi.searchBuilding(req)
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        if ("Success" == data.statusCode) {
          this.buildingList = [{buildingId: null, buildingName: ""}]
          for (let bodys of data.body.body) {
            this.buildingList.push({
              buildingId: bodys.buildingId,
              buildingName: bodys.buildingName,
            })
          }

          this.loadData()
        }
      })
    },
    getFloorSearch(){
      SystemManageApi.searchFloor({
        ownerId: this.ownerId,
        buildingId: this.query.buildingId,
        pageSize: 999,
        pageNumber: 1,
      })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(({ data }) => {
          this.floorList = [{buildingId: null, buildingName: "", floorId:null, floorName: ""}];
          if (data.body.body.length > 0) {
            for (let bodys of data.body.body) {
              this.floorList.push({
                buildingId: bodys.buildingId,
                buildingName: bodys.buildingName,
                floorId: bodys.floorId,
                floorName: bodys.floorName,
              });
            }
          }

          this.filterFloorList = this.floorList
        })
    },
    getAreaSearch(){
      SystemManageApi.searchArea({
        ownerId: this.ownerId,
        buildingId: this.query.buildingId,
        floorId: this.query.floorId,
        pageSize: 999,
        pageNumber: 1,
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .then(({ data }) => {
        this.areaList = [{buildingId: null, buildingName: "", floorId:null, floorName: "", areaId: null, areaName: ""}]

        if (data.body.body.length > 0) {
          for (let bodys of data.body.body) {
            this.areaList.push({
              buildingId: bodys.buildingId,
              buildingName: bodys.buildingName,
              floorId: bodys.floorId,
              floorName: bodys.floorName,
              areaId: bodys.areaId,
              areaName: bodys.areaName,
            });
          }
        }

        this.filterAreaList = this.areaList
      })
    },
    loadData(){
      SystemManageApi.deviceEnvViewPageSearch({
        ownerId: this.ownerId,
        buildingId: this.query.buildingId,
        floorId: this.query.floorId,
        areaId: this.query.areaId,
        pageAreaOnlyFlag: true,
        pageSize: 999,
        pageNumber: 1
      })
      .then(({ data }) => {
        this.searchResult = []
        if (data.body.body != undefined && data.body.body != null && data.body.body.length > 0) {
          for (const envView of data.body.body) {

            let buildEnv = this.buildingList.find(item => !this.$IsNullOrEmpty(item.buildingId) && item.buildingId == envView.buildingId)
            if (buildEnv == undefined || buildEnv == null) {
              continue
            }

            const basic = {
              ownerId: envView.ownerId,
              ownerName: envView.ownerName,
              ownerExId: envView.ownerExId,
              buildingId: envView.buildingId,
              buildingName: envView.buildingName,
              buildingExId: envView.buildingExId,
              floorId: envView.floorId,
              floorName: envView.floorName,
              areaId: envView.areaId,
              areaName: envView.areaName
            };
            if (envView.pageList.length > 0) {
              for (let page of envView.pageList) {
                this.searchResult.push({
                  ...basic,
                  ...page
                })
              }
            }

          }
        }

        this.filterSearchResult = this.searchResult
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
    },
    cancel () {
      this.handleDialogClose()
    },
    // Dialog閉じる
    handleDialogClose () {
      this.buildingList = []
      this.floorList = []
      this.areaList = []
      this.searchResult = []
      this.filterFloorList = []
      this.filterAreaList = []
      this.filterSearchResult = []
      this.dialogVisible = false
      this.query = {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floor: null,
        areaId: null,
        areaName: null,
        pageId: null,
        pageName: null,
      }
      this.$emit("update:visible", false)
    },

  }
};
</script>

<style lang="scss" scoped>
.search-popup {
  ::v-deep  .el-dialog {
    min-width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}


.viewable-area-style ::v-deep .el-dialog {
  padding-top: 0px !important;
}
.header-style {
  margin-top: 34px;
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
}

.m-r-16 {
  margin-right: 16px;
}
.title-style {
  font-family: Hiragino Kaku Gothic Pro;
  font-size: 24px;
  font-weight: 300;
  color: #525250;
}
.img-div {
  width: 410px;
  height: 229px;
  left: 542px;
  gap: 0px;
  border-radius: 8px 0px 0px 0px;
  border: 1px 0px 0px 0px;
  opacity: 0px;
}
</style>
